import styles from './links.less'; export {styles};
import Link from './links/link';
import Flags, {FlagData} from './flags';
import {MenuLinkData} from '../../shared/menu';

export interface LinksProps {
    currentCategoryIds?: string[];
    id?: number;
    name?: string;
    children: MenuLinkData[];
    otherChildren?: MenuLinkData[];
    flags?: FlagData[];
    active?: boolean;
    parentActive?: boolean;
    onLinksActivate?: Function;
    onPreviousClick?: Function;
    level: number;
}

export default class Links extends React.Component<LinksProps, null> {

    constructor(props) {
        super(props);
        this.onLinksActivate = this.onLinksActivate.bind(this);
    }

    isParentActive(): boolean {
        if (this.props.currentCategoryIds) {
            for (let child of this.props.children) {
                for (let id of this.props.currentCategoryIds) {
                    if (child.id == +id) {
                        return true;
                    }
                }
            }
        }

        return false;
    }

    isActive(): boolean {
        if (this.props.active) {
            return true;
        }

        for (let id of this.props.currentCategoryIds) {
            if (this.props.id == +id) {
                return true;
            }
        }

        return this.isParentActive();
    }

    onLinksActivate(links: number[]) {
        if (!links) {
            links = [];
        }

        if (this.props.id) {
            links.push(this.props.id);
        }

        this.props.onLinksActivate(links);
    }

    shouldComponentUpdate(nextProps: Readonly<LinksProps>, nextState: Readonly<null>, nextContext: any): boolean {
        if (this.props.active !== nextProps.active) {
            return true;
        }

        if (this.props.children !== nextProps.children) {
            return true;
        }

        return !AitiCore.getUtils().shallowEqual(this.props.currentCategoryIds, nextProps.currentCategoryIds);
    }

    render() {
        return (
            <div className={classNames(styles.children, {[styles.childrenActive]: this.isActive()})}>
                <div className={classNames(styles.list, {[styles.listActive]: this.isParentActive()})}>
                    {this.props.name && (
                        <div className={styles.handle} onClick={() => this.props.onPreviousClick()}>
                            {this.props.level > 0 && <div className={styles.previous}/>}
                            <div className={styles.name}>{this.props.name}</div>
                        </div>
                    )}

                    {this.props.children.map((link, idx) =>
                        <Link
                            id={link.id}
                            key={link.id || idx}
                            name={link.name}
                            url={link.url}
                            hasChildren={link.children.length > 0}
                            onLinksActivate={this.onLinksActivate}
                        />
                    )}

                    {this.props.otherChildren && (
                        <div className={styles.others}>
                            {this.props.otherChildren && this.props.otherChildren.map((link, idx) =>
                                <Link
                                    id={link.id}
                                    key={link.id || idx}
                                    name={link.name}
                                    url={link.url}
                                    hasChildren={link.children.length > 0}
                                    onLinksActivate={this.onLinksActivate}
                                />
                            )}

                            {this.props.flags && (
                                <Flags
                                    flags={this.props.flags}
                                />
                            )}
                        </div>
                    )}
                </div>

                {this.props.children.map((link, idx) =>
                    (link.children.length > 0 && (
                        <Links
                            currentCategoryIds={this.props.currentCategoryIds}
                            id={link.id}
                            key={link.id}
                            name={link.name}
                            children={link.children}
                            onLinksActivate={this.onLinksActivate}
                            onPreviousClick={this.props.onPreviousClick}
                            level={this.props.level + 1}
                        />
                    ))
                )}
            </div>
        );
    }
}
